module.exports = __webpack_public_path__ + "assets/link.82d3cc2b.svg";